import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Warm the react-query cache for a GET endpoint (used for hover-prefetch).
export function prefetchGet(queryClient, queryKey, url) {
  queryClient.prefetchQuery({
    queryKey,
    queryFn: async () => (await api.get(url)).data,
    staleTime: 60_000,
  });
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
